import DateTime from '../../../helpers/DateTime';
import ExplosivePrecursorFormValidation from '../explosives/ExplosivePrecursorFormValidation';
import MachineAgrementFormValidation from '../machine/MachineAgrementFormValidation';
import DistillateFormValidation from '../distillate/DistillateFormValidation';
import MachineAgreementReview from '../machine/MachineAgreementReview';
import ExplosivePrecursorReview from '../explosives/ExplosivePrecursorReview';
import DistillateReview from '../distillate/DistillateReview';
import recieverFields from './json/commonRecieverFields.json';

/**
 * Shared Class for E-signing.
 * Populates Reciever dropdown and sets the Reciever data.
 */
export default class RecieverForm {
    /**
     * Constructor
     * @param {*} agreementType
     */
    constructor(agreementType) {
        this.reciever = {};
        this.validation = {};

        // Date Helper
        this.dateTime = new DateTime();
        this.validThroughDate = this.dateTime.addMonths(new Date(), 12).toString();

        // Agrement type
        this.agreementType = agreementType;

        // Json data for common fields
        this.recieverFields = recieverFields;

        // EventListerners
        this.initEventListerners();
    }

    /**
     * @description Inits the parent classes in seperate method
     * to avoid Stack overload
     * @param {string} classDefinition
     * @returns void
     */

    initParentClasses(classDefinition) {
        switch (this.agreementType) {
            case 'machines':
                if (classDefinition === 'reciever') {
                    this.reciever = new MachineAgreementReview(this.validThroughDate);
                    this.reciever.recieverEventListerner();
                }

                if (classDefinition === 'validation') {
                    this.validation = new MachineAgrementFormValidation();
                }

                break;
            case 'explosives':
                if (classDefinition === 'reciever') {
                    this.reciever = new ExplosivePrecursorReview(this.validThroughDate);
                }

                if (classDefinition === 'validation') {
                    this.validation = new ExplosivePrecursorFormValidation();
                }

                break;
            case 'distillate':
                if (classDefinition === 'reciever') {
                    this.reciever = new DistillateReview(this.validThroughDate);
                }

                if (classDefinition === 'validation') {
                    this.validation = new DistillateFormValidation();
                }

                break;
        }
    }

    /**
     * Hide Personal number field
     * @param {*} recieverFields
     * @param {*} key
     */
    hidePersonalDataField(recieverFields, key) {
        // Hiding PersonalNumber field if there is data
        var parentDiv = document.getElementById(recieverFields[key].input).parentNode;
        if (
            recieverFields[key].input === 'ReceiverPersonalNumber' &&
            document.getElementById(recieverFields[key].input).value !== ''
        ) {
            document.getElementById(recieverFields[key].input).setAttribute('type', 'hidden');
            parentDiv.classList.add('hidden');
        } else if (recieverFields[key].input === 'ReceiverPersonalNumber') {
            document.getElementById(recieverFields[key].input).setAttribute('type', 'text');
            parentDiv.classList.remove('hidden');
        }
    }

    /**
     * @description Conceal Personal data
     * @param {*} recieverFields
     * @param {*} key
     */
    concealPersonalData(recieverFields, key) {
        if (
            recieverFields[key].reviewClass === '.review_receiver_personal_number' &&
            document.getElementById(recieverFields[key].input).value !== ''
        ) {
            document.querySelector(recieverFields[key].reviewClass).innerHTML = document
                .getElementById(recieverFields[key].input)
                .value.replace(/\d(?=(?:\D*\d){0,3}$)/g, '*');
        }
    }

    /**
     * @description Event Listerners
     * @returns void
     */
    initEventListerners() {
        for (let item of document.querySelectorAll('.step2')) {
            item.addEventListener('blur', () => {
                this.signerFields(false);
            });
        }
    }

    /**
     * @description Set DropDown data
     * @param {Object} result
     * @returns void
     */
    setRecieverDropDown = (result) => {
        if (!result) {
            return false;
        }

        const dropDown = document.querySelector('.receiverDropdown .dropdown');

        for (let item of result) {
            let listItem = document.createElement('li');
            let roles = item.RoleProfileName ? item.RoleProfileName : '';
            let cssClass = 'dropDownTrigger';

            listItem.setAttribute('class', cssClass);
            listItem.setAttribute('data-email', item.Email ? item.Email : '');
            listItem.setAttribute('data-name', item.Name ? item.Name : '');
            listItem.setAttribute(
                'data-personalnumber',
                item.PersonalNumber ? item.PersonalNumber : ''
            );

            listItem.setAttribute(
                'data-mobilephonenumber',
                item.MobilePhoneNumber ? item.MobilePhoneNumber : ''
            );

            listItem.textContent = item.Name ? `${roles} (${item.Name})` : '';
            listItem.addEventListener('click', (result) => {
                this.setRecieverfieldsFromDropDown(result);
                this.initParentClasses('validation');
                this.validation.checkForm('reciever');
            });

            dropDown.appendChild(listItem);
        }
    };

    /**
     * @description Set Reciever fields from selected reciever
     * @param {Object} evt
     * @returns void
     */
    setRecieverfieldsFromDropDown = (evt) => {
        for (let item of document.querySelectorAll('li.dropDownTrigger ')) {
            item.classList.remove('selected');
        }

        evt.target.classList.add('selected');

        document.querySelector('.receiverDropdown .showcase a').innerHTML = evt.target.innerHTML;
        document.querySelector('.receiverDropdown .dropdown').style.display = 'none';

        for (let item of document.querySelectorAll('div.agreementElement')) {
            item.classList.remove('disabled');
        }

        this.signerFields(true);

        // Signer - Email
        // ---------------------------------------------
        document.getElementById('Signer').value = evt.target.getAttribute('data-email') || '';
    };

    /**
     * @description Set Signer fields
     * @param {*} template
     * @returns void
     */
    signerFields(template) {
        this.initParentClasses('reciever');

        let element = template
            ? document.querySelector('.receiverDropdown .showcase li.selected')
            : '';

        // Common customer reciever fields
        // ---------------------------------------------
        for (let key in this.recieverFields) {
            if (element) {
                let attribute = {};
                document.getElementById(recieverFields[key].input).value = element.getAttribute(
                    recieverFields[key].attribute
                );

                document.querySelector(recieverFields[key].reviewClass).innerHTML =
                    element.getAttribute(recieverFields[key].attribute);

                attribute[recieverFields[key].payloadProp] = element.getAttribute(
                    recieverFields[key].attribute
                );

                this.reciever.preparePayLoad(attribute);
            } else {
                let attribute = {};
                document.querySelector(recieverFields[key].reviewClass).innerHTML =
                    document.getElementById(recieverFields[key].input).value;

                attribute[recieverFields[key].payloadProp] = document.getElementById(
                    recieverFields[key].input
                ).value;

                this.reciever.preparePayLoad(attribute);
            }

            if (template) {
                this.hidePersonalDataField(recieverFields, key);
            }

            this.concealPersonalData(recieverFields, key);
        }

        // Customer number - TODO: Need check for query version.
        // ---------------------------------------------
        this.reciever.preparePayLoad({
            customerNumber: document.getElementById('customerNumberElementId').value,
        });

        // Agreement type
        // ---------------------------------------------
        this.reciever.preparePayLoad({
            AgreementType: this.agreementType,
        });

        // Check form
        // ---------------------------------------------
        this.initParentClasses('validation');
        this.validation.checkForm('reciever');
    }
}
